import React, { useState, useEffect } from "react";
import Constants from "../components/Constant.js";
import {
  TextField,
  Button,
  Container,
  Box,
  Typography,
  Grid,
  Autocomplete,
  Snackbar,
  Alert,
} from "@mui/material";
import MainLayout from "../components/MainLayout.js";
import backgroundImage from "../assets/backgroundHome.png";

export default function EditarCartaoPRE() {
  const [cartoes, setCartoes] = useState([]);
  const [filteredCartoes, setFilteredCartoes] = useState([]);
  const [selectedCartao, setSelectedCartao] = useState(null);
  const [searchCartao, setSearchCartao] = useState("");
  const [orgaos, setOrgaos] = useState([]);
  const [formData, setFormData] = useState({
    senha: "",
  });
  const [errors, setErrors] = useState({});
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const token = localStorage.getItem("token") || sessionStorage.getItem("token");
  const prefeituraId = localStorage.getItem("prefeituraId") || sessionStorage.getItem("prefeituraId");

  useEffect(() => {
    const fetchCartoes = async () => {
      if (!prefeituraId) {
        showSnackbar("Erro ao identificar a prefeitura.", "error");
        return;
      }

      try {
        const response = await fetch(`${Constants.API_BASE_URL}/api/listarPrefeitura/${prefeituraId}`, {
          headers: {
            "Authorization": `Bearer ${token}`
          }
        });
        const data = await response.json();
        if (response.ok && data.status) {
          setCartoes(data.prefeitura.cartoes);
          setFilteredCartoes(data.prefeitura.cartoes);
        } else {
          showSnackbar("Erro ao buscar cartões.", "error");
        }
      } catch (error) {
        console.error("Erro ao conectar com o servidor:", error);
        showSnackbar("Erro ao conectar com o servidor.", "error");
      }
    };

    const fetchOrgaos = async () => {
      if (!prefeituraId) {
        showSnackbar("Erro ao identificar a prefeitura.", "error");
        return;
      }

      try {
        const response = await fetch(`${Constants.API_BASE_URL}/api/orgaosPrefeitura/${prefeituraId}`, {
          headers: {
            "Authorization": `Bearer ${token}`
          }
        });
        const data = await response.json();
        if (response.ok) {
          let orgaosArray = [];
          if (data.orgaos) {
            orgaosArray = Object.values(data.orgaos);
          } else if (Array.isArray(data)) {
            orgaosArray = data;
          } else if (data.data && Array.isArray(data.data)) {
            orgaosArray = data.data;
          }
          setOrgaos(orgaosArray);
        } else {
          showSnackbar("Erro ao buscar órgãos.", "error");
        }
      } catch (error) {
        console.error("Erro ao buscar órgãos:", error);
        showSnackbar("Erro ao buscar órgãos.", "error");
      }
    };

    fetchCartoes();
    fetchOrgaos();
  }, [prefeituraId, token]);

  useEffect(() => {
    if (searchCartao) {
      const filtered = cartoes.filter((cartao) =>
        cartao.CAR_ID.toString().toLowerCase().includes(searchCartao.toLowerCase()) ||
        (cartao.CAR_RESP_NOME && cartao.CAR_RESP_NOME.toLowerCase().includes(searchCartao.toLowerCase()))
      );
      setFilteredCartoes(filtered);
    } else {
      setFilteredCartoes(cartoes);
    }
  }, [searchCartao, cartoes]);

  useEffect(() => {
    if (selectedCartao) {
      setFormData({
        senha: selectedCartao.CAR_SENHA || "",
      });
    }
  }, [selectedCartao]);

  const handleCartaoChange = (_, newValue) => {
    setSelectedCartao(newValue);
    setErrors({});
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.senha) {
      newErrors.senha = "Senha é obrigatória";
    } else if (formData.senha.length < 4) {
      newErrors.senha = "Senha deve ter pelo menos 4 caracteres";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!selectedCartao) {
      showSnackbar("Selecione um cartão para editar.", "error");
      return;
    }

    if (!validateForm()) {
      showSnackbar("Por favor, corrija os erros no formulário.", "error");
      return;
    }

    try {
      const response = await fetch(`${Constants.API_BASE_URL}/api/cartao/${selectedCartao.CAR_ID}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({
          CAR_ID_ORGAO_RESP: selectedCartao.CAR_ID_ORGAO_RESP,
          CAR_SENHA: formData.senha,
          CAR_TIPO: selectedCartao.CAR_TIPO
        }),
      });

      if (response.ok) {
        showSnackbar("Cartão atualizado com sucesso!", "success");
        // Atualiza a lista de cartões
        const updatedCartoes = cartoes.map(cartao => 
          cartao.CAR_ID === selectedCartao.CAR_ID 
            ? { 
                ...cartao, 
                CAR_SENHA: formData.senha
              }
            : cartao
        );
        setCartoes(updatedCartoes);
        setFilteredCartoes(updatedCartoes);
        
        // Limpa os campos após salvar
        setSelectedCartao(null);
        setFormData({
          senha: "",
        });
        setErrors({});
      } else {
        const data = await response.json();
        showSnackbar(data.message || "Erro ao atualizar cartão.", "error");
      }
    } catch (error) {
      console.error("Erro ao conectar com o servidor:", error);
      showSnackbar("Erro ao conectar com o servidor.", "error");
    }
  };

  const showSnackbar = (message, severity = "success") => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <MainLayout>
      <Box
        sx={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundColor: "rgba(255, 255, 255, 0.8)",
          backgroundBlendMode: "overlay",
          padding: 2,
          borderRadius: 2,
          boxShadow: 3,
        }}
      >
        <Container maxWidth="md">
          <Box sx={{ p: { xs: 2, sm: 4 }, bgcolor: "background.paper", borderRadius: 2, boxShadow: 3 }}>
            <Typography variant="h4" component="h1" gutterBottom align="center" sx={{ fontSize: { xs: "1.5rem", sm: "2rem" } }}>
            Editar Senha do Cartão
            </Typography>

            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Autocomplete
                  options={filteredCartoes}
                  getOptionLabel={(option) => 
                    option ? `Cartão ${option.CAR_ID} - ${option.CAR_RESP_NOME || 'Sem responsável'} (${option.CAR_TIPO || 'COMUM'})` : ""
                  }
                  value={selectedCartao}
                  onChange={handleCartaoChange}
                  onInputChange={(_, newInputValue) => {
                    setSearchCartao(newInputValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Selecione um Cartão"
                      fullWidth
                      margin="normal"
                      size="medium"
                      helperText="Selecione um cartão para editar"
                      sx={{ "& .MuiInputBase-root": { height: "56px" } }}
                    />
                  )}
                  renderOption={(props, option) => (
                    <li {...props}>
                      <strong>Cartão {option.CAR_ID}</strong> - {option.CAR_RESP_NOME || 'Sem responsável'} ({option.CAR_TIPO || 'COMUM'})
                    </li>
                  )}
                />
              </Grid>

              {selectedCartao && (
                <>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Senha *"
                      name="senha"
                      type="password"
                      value={formData.senha}
                      onChange={handleInputChange}
                      error={!!errors.senha}
                      helperText={errors.senha}
                      margin="normal"
                      size="medium"
                      sx={{ "& .MuiInputBase-root": { height: "56px" } }}
                      inputProps={{ maxLength: 20 }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSubmit}
                        sx={{ height: "56px", width: "200px" }}
                      >
                        Salvar Alterações
                      </Button>
                    </Box>
                  </Grid>
                </>
              )}
            </Grid>
          </Box>
        </Container>

        <Snackbar
          open={snackbarOpen}
          autoHideDuration={6000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleSnackbarClose}
            severity={snackbarSeverity}
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Box>
    </MainLayout>
  );
} 